function escapePythonString(value) {
  return String(value === undefined || value === null ? '' : value)
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'");
}

function toPythonValue(value) {
  if (Array.isArray(value)) {
    return `[${value.map(toPythonValue).join(', ')}]`;
  }

  if (value && typeof value === 'object') {
    return `{${Object.entries(value)
      .map(([key, item]) => `'${escapePythonString(key)}': ${toPythonValue(item)}`)
      .join(', ')}}`;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  return `'${escapePythonString(value)}'`;
}

function resultToPythonScript(result, signature) {
  const rows = result.sequence.map((patient) => ({
    patient_id: patient.patientId,
    sequence_order: patient.sequenceOrder,
    arm: patient.arm,
    arm_index: patient.armIndex + 1,
    block: patient.blockNumber || '',
    cluster: patient.cluster || '',
    stratum: patient.stratum || ''
  }));

  const metadata = {
    randflow_version: result.version,
    generated_at: result.timestamp,
    study_name: result.parameters.studyName || '',
    technique: result.algorithm,
    algorithm_id: result.algorithmId,
    seed: result.seed,
    participants: result.parameters.n,
    arms: result.parameters.arms,
    arm_labels: result.parameters.armLabels,
    validation: result.metrics.validation,
    imbalance: result.metrics.imbalance,
    imbalance_percent: result.metrics.imbalancePercent,
    experiment_signature: signature
  };

  return `# randFlow Python export
# Recreate the randomization dataframe with pandas.

import pandas as pd

randflow_metadata = ${toPythonValue(metadata)}

randflow_randomization = pd.DataFrame(${toPythonValue(rows)})

arm_summary = (
    randflow_randomization
    .groupby('arm', as_index=False)
    .size()
    .rename(columns={'size': 'n'})
)

print(randflow_metadata)
print(arm_summary)
`;
}

module.exports = {
  resultToPythonScript
};
